import * as React from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../store'
import RegionModel from '../models/RegionModel'
import { Buttons, Col, Grid, IdFormField, Row, TextFormField, apiCallWrapperNoDispatch, nameof } from 'traveldesk-ui'
import { slugify } from 'transliteration'

interface Props {
    region: RegionModel
    onCancel: () => void
    onSaved: (region: RegionModel) => void
}
const RegionForm = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const { handleSubmit, formState: { errors }, control, register, reset, setValue, watch } = useForm()
    const name = watch('name')

    const onSubmit = async (data: any) => {
        const model = Object.assign(new RegionModel(), data, { cityId: props.region.cityId, countryId: props.region.countryId })
        const response = await apiCallWrapperNoDispatch<RegionModel>('/api/regions', 'POST', model)
        if (response.IsOk && response.Content) {
            props.onSaved(response.Content)
            return
        }

        alert("Couldn't save region: " + response.ErrorMessage)
    }

    React.useEffect(() => {
        reset(props.region)
    }, [props.region])
    React.useEffect(() => {
        setValue(nameof<RegionModel>('url'), slugify(name ?? ''))
    }, [name])

    return (
        <Grid style={{ backgroundColor:'white', border: "1px solid #aaa", borderRadius: "5px", padding: "20px" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col type="100">
                        <h3>
                            {props.region.id > 0
                                ? Localization.getString('Edit Region')
                                : Localization.getString('Add Region')}
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col type="50">
                        <IdFormField control={control} />
                        <TextFormField
                            label={Localization.getString('Region Name')}
                            placeholder={Localization.getString('Name of the region')}
                            isRequired
                            error={errors.name ? errors.name.message : ''}
                            name={nameof<RegionModel>('name')}
                            register={register}
                            options={{
                                required: Localization.getString('Region name is required'),
                            }}
                        />                        
                    </Col>
                    <Col type="50">
                        <TextFormField
                            label={Localization.getString('Slug')}
                            placeholder={Localization.getString('Url of the region')}
                            isRequired
                            error={errors.url ? errors.url.message : ''}
                            name={nameof<RegionModel>('url')}
                            register={register}
                            options={{
                                required: Localization.getString('Region slug is required'),
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col type="100">                       
                        <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
                    </Col>
                </Row>
            </form>
        </Grid>
    )
}
export default RegionForm